import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from "tss-react/mui";
import OutlinedInput from '@mui/material/OutlinedInput';
import Select from '@mui/material/Select';
import styles from './styles';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

class DropDown extends React.Component {
    constructor(props) {
        super(props);

        this.targetRef = React.createRef();
        this.targetElement = null;
    }

    componentDidMount() {
        this.targetElement = this.targetRef.current;
    }

    componentWillUnmount() {

        clearAllBodyScrollLocks();
    }

    render() {
        const { classes, ...other } = this.props;
        return (
            <Select ref={this.targetRef}
                className={classes.dropDown}
                fullWidth
                margin="none"
                variant="filled"
                input={<OutlinedInput
                    className={this.dropDown} {...this.props.inputProps} />}
                onOpen={this.onOpen}
                onClose={this.onClose}
                {...other}>
                {this.props.children}
            </Select>
        );
    }

    onOpen = () => {
        disableBodyScroll(this.targetElement);
    };

    onClose = () => {
        enableBodyScroll(this.targetElement);
    };
}

DropDown.propTypes = {
    classes: PropTypes.object
};

export default withStyles(DropDown, styles);